// src/privacy/cookies/cookieConsent.ts

export type CookieConsentState = {
    version: number; // bump if you change categories/meaning
    updatedAt: string; // ISO timestamp
    essential: true; // always true
    analytics: boolean;
    marketing: boolean;
  };
  
  const STORAGE_KEY = "cookie_consent_v1";
  const CONSENT_VERSION = 1;
  
  export const defaultConsent: CookieConsentState = {
    version: CONSENT_VERSION,
    updatedAt: new Date().toISOString(),
    essential: true,
    analytics: false,
    marketing: false,
  };
  
  export function getStoredConsent(): CookieConsentState | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as CookieConsentState;
  
      // If you ever change meaning/categories, force re-consent:
      if (parsed.version !== CONSENT_VERSION) return null;
  
      // Ensure essential is always true
      return { ...parsed, essential: true };
    } catch {
      return null;
    }
  }
  
  export function storeConsent(consent: CookieConsentState) {
    const payload: CookieConsentState = {
      ...consent,
      essential: true,
      version: CONSENT_VERSION,
      updatedAt: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  
    // Optional: let the rest of your app react (analytics loader etc.)
    window.dispatchEvent(new CustomEvent("cookie-consent-updated", { detail: payload }));
  }
  
  export function clearConsent() {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent("cookie-consent-cleared"));
  }
  
  export function hasConsentFor(category: "analytics" | "marketing"): boolean {
    const c = getStoredConsent();
    return !!c?.[category];
  }
  